module.exports = __webpack_public_path__ + "img/ico-unativate-cam.698e250c.svg";